<template>
  <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="default"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        ref="form"
        :data-url="
          selectedUrl
            ? `/accreditations/rehearsalActivities/${inputs.id}`
            : '/accreditations/rehearsalActivities'
        "
      >
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>NOMBRE LABORATORIO</label>
              <app-input
                type="text"
                v-model="inputs.name"
                placeholder="Ingrese el nombre del laboratorio"
                :required="true"
              />
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label>RELACIÓN CONTRACTUAL</label>
              <app-input
                type="text"
                v-model="inputs.relationship"
                :required="true"
                placeholder="Ingrese la relación contractual"
              />
            </div>
          </div>

          <div class="col-12" v-if="['OICC'].includes(this.activity)">
            <div class="form-group">
              <label>UNIDAD TÉCNICA</label>
              <app-input
                type="text"
                v-model="inputs.technical_unit"
                placeholder="Ingrese la unidad técnica"
                :required="true"
              />
            </div>
          </div>

          <div class="col-12" v-if="['OEAP'].includes(this.activity)">
            <div class="form-group">
              <label>ACTIVIDAD</label>
              <app-input
                type="text"
                v-model="inputs.activity"
                placeholder="Ingrese la actividad"
                :required="true"
              />
            </div>
          </div>

          <div class="col-12" v-if="['OICC'].includes(this.activity)">
            <div class="form-group">
              <label>MÉTODO DE ENSAYO</label>
              <app-input
                type="text"
                v-model="inputs.testing_method"
                placeholder="Ingrese el método de ensayo"
                :required="true"
              />
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label>PERFIL DEL PERSONAL</label>
              <app-input
                type="text"
                v-model="inputs.profile"
                placeholder="Ingrese el perfil del personal"
                :required="true"
              />
            </div>
          </div>

          <div class="col-12" v-if="['OICC'].includes(this.activity)">
            <div class="form-group">
              <label
                >NOMBRE DEL PERSONAL CALIFICADO PARA CADA ENSAYO O ACTIVIDAD
                DESCRITA</label
              >
              <app-input
                type="text"
                v-model="inputs.qualified_personnel"
                placeholder="Ingrese el nombre del personal"
                :required="true"
              />
            </div>
          </div>

          <div class="col-12" v-if="['OEAP'].includes(this.activity)">
            <div class="form-group">
              <label>AUTORIZACIÓN PARA</label>
              <app-input
                type="text"
                v-model="inputs.authorization_for"
                placeholder="Ingrese la autorización"
                :required="true"
              />
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label>OBSERVACIONES</label>
              <app-input
                type="textarea"
                v-model="inputs.observations"
                placeholder="Ingrese las observaciones"
                :required="true"
              />
            </div>
          </div>
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        @click.prevent="submit"
        :disabled="disabledSubmit"
      >
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    modalTitle: String,
    editModalTitle: String,
    selectedUrl: String,
    activity: String,
  },
  data() {
    return {
      preloader: false,
      inputs: {},
      modalId: "add-edit-modal",
      disabledSubmit: false,
    };
  },
  computed: {
    title() {
      return this.selectedUrl ? this.editModalTitle : this.modalTitle;
    },
  },
  created() {
    if (this.selectedUrl) {
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      this.inputs.acc_app_id = this.$store.state.accreditation.id;
      this.disabledSubmit = true;
      this.save(this.inputs);
    },

    afterJsValidationFail() {
      this.disabledSubmit = false;
    },

    afterSuccess(response) {
      // this.$toastr.s(response.data.message);
      if (this.inputs.id) {
        this.$toastr.s(this.$t("updated_success"));
      } else {
        this.$toastr.s(this.$t("created_success"));
      }
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      this.inputs = response.data;
      this.preloader = false;
    },
  },
};
</script>
